var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-wrapper"},[_c('div',{staticClass:"empty-text"},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),(_vm.buttonText)?_c('div',{staticClass:"empty-btn buttons"},[_c('el-button',{staticClass:"blue-bg",attrs:{"type":"primary"},on:{"click":function($event){return _vm.$emit('emptyClick')}}},[_vm._v(_vm._s(_vm.buttonText))])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a17d8ee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/model/isEmpty.vue
// module id = null
// module chunks = 